import { render, staticRenderFns } from "./FileDetails.html?vue&type=template&id=0ff0d7dc&scoped=true&"
import script from "./FileDetails.js?vue&type=script&lang=js&"
export * from "./FileDetails.js?vue&type=script&lang=js&"
import style0 from "./FileDetails.scss?vue&type=style&index=0&id=0ff0d7dc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff0d7dc",
  null
  
)

export default component.exports